import React, { useState, useEffect } from 'react'
import './title_function.css'

const TitleJob = () => {
 const words = ["Hi,I'm a DevOps Engineer Mid Level", 'and a Django Developer Mid Level', "Let's work together",];
 const speed = 100;
 const skip_delay = 25;

 const [i, setI] = useState(0);
 const [offset, setOffset] = useState(0);
 const [forwards, setForwards] = useState(true);
 const [skipCount, setSkipCount] = useState(0);
 const [part, setPart] = useState(words[i].substr(0, offset));

 useEffect(() => {
    const timer = setInterval(() => {
      if (forwards) {
        if (offset >= words[i].length) {
          setSkipCount((prevSkipCount) => prevSkipCount + 1);
          if (skipCount === skip_delay) {
            setForwards(false);
            setSkipCount(0);
          }
        }
      } else {
        if (offset === 0) {
          setForwards(true);
          setI((prevI) => (prevI + 1) % words.length);
          setOffset(0);
        }
      }
      setPart(words[i].substr(0, offset));
      if (skipCount === 0) {
        if (forwards) {
          setOffset((prevOffset) => prevOffset + 1);
        } else {
          setOffset((prevOffset) => prevOffset - 1);
        }
      }
    }, speed);
    return () => clearInterval(timer);
 }, [i, offset, forwards, skipCount]);

 return <div data-aos="fade-up" className="word">{part}</div>;
};

export default TitleJob;